import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return <div className={className} style={{ ...style, display: "block", background: "#002b5b", borderRadius: "50%" }} onClick={onClick} />;
};

const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return <div className={className} style={{ ...style, display: "block", background: "#002b5b", borderRadius: "50%" }} onClick={onClick} />;
};

const ClientSlider = () => {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);

    // Dynamic BASE_URL based on hostname (jaise baaki files mein hai)
    const BASE_URL = window.location.hostname === 'localhost'
        ? 'http://127.0.0.1:8001'
        : 'https://rbmchemicals.com';

    const API_URL = `${BASE_URL}/api/get_clients/`;

    useEffect(() => {
        fetch(API_URL)
            .then(res => res.json())
            .then(data => {
                const clientList = Array.isArray(data) ? data : (data.results || data.clients || []);
                setClients(clientList);
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching clients:", err);
                setLoading(false);
            });
    }, [API_URL]);

    const settings = {
        dots: false,
        infinite: clients.length > 3,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <section className="py-16 bg-white container mx-auto px-4 md:px-10">
            <h2 className="text-3xl font-bold text-[#002b5b] text-center mb-8">RBM CHEMICALS ESTEEMED CLIENTS</h2>
            <div className="border-b-2 border-gray-300 w-24 mx-auto mb-10"></div>

            {loading ? (
                <p className="text-center text-gray-500">Loading Clients...</p>
            ) : clients.length > 0 ? (
                <Slider {...settings}>
                    {clients.map((client, index) => {
                        let imageUrl = 'https://via.placeholder.com/150';
                        if (client.image) {
                            if (client.image.startsWith('http')) {
                                imageUrl = client.image;
                            } else if (client.image.startsWith('/')) {
                                imageUrl = `${BASE_URL}${client.image}`;
                            } else {
                                imageUrl = `${BASE_URL}/${client.image}`;
                            }
                        }

                        return (
                            <div key={client.id || index} className="px-2">
                                <div className="h-40 md:h-32 w-full flex items-center justify-center border border-gray-200 bg-white hover:shadow-lg transition overflow-hidden p-2">
                                    <img
                                        src={imageUrl}
                                        alt={client.name || "Client Logo"}
                                        className="w-full h-full object-contain"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = 'https://via.placeholder.com/150';
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </Slider>
            ) : (
                <p className="text-center text-gray-500">No clients to display.</p>
            )}
        </section>
    );
};

export default ClientSlider;